export enum NewAccountStep {
	Company = 1,
	Subscription = 2,
	Validation = 3,
}
